import { Directive, ElementRef, effect, inject, signal } from '@angular/core';

@Directive({
  selector: '[cueHasScrollbar]',
  standalone: true,
  host: {
    '[class.has-scrollbar]': 'hasScrollbar()',
  },
})
export class HasScrollbarDirective {
  private readonly element = inject(ElementRef<HTMLElement>).nativeElement as HTMLElement;
  protected readonly hasScrollbar = signal(false);

  private readonly observeScrollbar = effect((onCleanup) => {
    const update = () => this.hasScrollbar.set(this.element.scrollHeight > this.element.clientHeight);

    const observer = new ResizeObserver(update);
    observer.observe(this.element);
    if (this.element.firstElementChild) {
      observer.observe(this.element.firstElementChild);
    }
    update();

    onCleanup(() => observer.disconnect());
  });
}
